import React, { KeyboardEvent, useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'

import parsePhoneNumberFromString, { CountryCode, getCountries, getCountryCallingCode } from 'libphonenumber-js'
import Image from 'next/image'

import Select from '../Select/SelectView'

import styles from './PhoneInput.module.css'

const getFlagSrc = (value: string) => `https://purecatamphetamine.github.io/country-flag-icons/3x2/${value}.svg`

export default function CountrySelect({
  name,
  value,
  onChange,
}: {
  name: string
  value: CountryCode
  onChange: (value: CountryCode) => void
}) {
  const { setValue, getValues } = useFormContext()

  const [search, setSearch] = useState('')

  const options = getCountries().map(countryCode => ({
    label: `+${getCountryCallingCode(countryCode)}`,
    value: countryCode,
  }))

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    const char = e.key.length === 1 ? e.key : ''
    if (e.key === 'Backspace') setSearch(prev => prev.slice(0, -1))
    if (!/^[0-9]$/.test(char)) return
    if (char) setSearch(prev => prev + char)
  }

  const filteredOptions = useMemo(() => options.filter(o => o.label.toLowerCase().includes(search.toLowerCase())), [options, search])

  return (
    <Select
      theme={styles}
      items={filteredOptions}
      value={value}
      onKeyDown={handleKeyDown}
      onChange={({ value }) => {
        const country = value[0] as CountryCode

        const parsedNumber = parsePhoneNumberFromString(getValues()[name])

        setValue(name, `+${getCountryCallingCode(country)}${parsedNumber?.nationalNumber}`, {
          shouldValidate: true,
          shouldDirty: true,
          shouldTouch: true,
        })
        onChange(country)
      }}
      renderOption={item => (
        <div className={styles.optionContainer}>
          <Image alt='option country flag' src={getFlagSrc(item.value)} width={20} height={20} />
          {item.label}
        </div>
      )}
      renderValue={() => (
        <div className={styles.trigger}>
          <Image alt='country flag' src={getFlagSrc(value)} width={16} height={16} />
          <p>+{getCountryCallingCode(value)}</p>
          <Image draggable={false} src={'/lp/assets/icons/arrow.svg'} alt='arrow down' width={16} height={16} />
        </div>
      )}
    />
  )
}
